// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__Ci25p","header":"ErrorPage_header__CtmnK","info":"ErrorPage_info__eMcFc","logo":"ErrorPage_logo__4+otd","button":"ErrorPage_button__dTWXK"};